import { render, staticRenderFns } from "./SchedulingList.vue?vue&type=template&id=22255440&"
import script from "./SchedulingList.vue?vue&type=script&lang=js&"
export * from "./SchedulingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports